/* eslint-disable @typescript-eslint/naming-convention */
import { MROCartApiResponse } from "./LocalCart";
import { MRONativeLocalCart } from "./MROLocalCart";
import { QuickCheckoutCartApiStatus } from "./QuickCheckout";

export enum GlobalJSBridgeType {
    INVALID = "INVALID",
    IPL_SWIGGY_SIX_OFFER_EXPIRY_TIMER_UPDATE = "IPL_SWIGGY_SIX_OFFER_EXPIRY_TIMER_UPDATE",
    UPDATE_QUICK_CHECKOUT_FOOTER = "UPDATE_QUICK_CHECKOUT_FOOTER",
}

export interface IPLSwiggySixesDataPayload {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    expiry_time_in_sec?: number;
}

export interface UpdateQuickCheckoutDataPayload {
    /** Only the `success` status carries a cart; `loading`/`failed` are status-only updates. */
    local_cart?: MRONativeLocalCart;
    cart_response?: MROCartApiResponse;
    cart_update_status: QuickCheckoutCartApiStatus;
    /**
     * Present on `success` payloads. Epoch-ms timestamp used to race direct-bridge prefetch
     * (`cart_prefetched_response.last_updated_timestamp`) against JS-bridge updates — newer wins.
     * Same field name on both transports.
     */
    last_updated_timestamp?: string | number;
}

export type GlobalJSBridgePayload = {
    type: GlobalJSBridgeType;
    data?: IPLSwiggySixesDataPayload | UpdateQuickCheckoutDataPayload;
};
